"use strict";

class SuperUserFeedbackViewController {

    constructor($scope, $parse, SSHttpService, SSUtilService, SSAppService, SSAlertService, OTPService, SSUserService) {
        const self = this;

        self.$scope = $scope;
        self.$parse = $parse;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.SSUserService = SSUserService;

        self.data = SHOWSUITE.data;

        self.USER_FEEDBACK_TYPE_PRE_REGISTER_UPDATES = SHOWSUITE.USER_FEEDBACK_TYPE_PRE_REGISTER_UPDATES;
        self.USER_FEEDBACK_TYPE_PRE_REGISTER_BROKER_WORKSHOP = SHOWSUITE.USER_FEEDBACK_TYPE_PRE_REGISTER_BROKER_WORKSHOP;

        self.feedbackTypes = {};
        self.feedbackTypes[self.USER_FEEDBACK_TYPE_PRE_REGISTER_UPDATES] = 'Pre Register Updates';
        self.feedbackTypes[self.USER_FEEDBACK_TYPE_PRE_REGISTER_BROKER_WORKSHOP] = 'Pre Register Broker Workshop';

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.apiOffset = 0;
        self.apiLimit = 10;

        self.userFeedbacks = null;
        self.userFeedbacksFiltered = null;
        self.searchParams = {};

        self.getUserFeedbacks();
    }

    getUserFeedbacks() {
        const self = this;

        self.userFeedbacksFiltered = null;
        self.userFeedbacks = null;

        let url = 'sec/super/users-feedback';
        self.searchParams.offset = self.apiOffset;
        self.searchParams.limit = self.apiLimit;

        loading(true);
        self.SSHttpService.postAPIRequest(url, self.searchParams).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.userFeedbacks = response.data.userFeedbacks;
            self.count = response.data.count;
            self.pages = Math.ceil(self.count / self.apiLimit);
            self.selectedPage = Math.floor(self.apiOffset / self.apiLimit) + 1;
        });
    }

    reset() {
        const self = this;

        self.searchParams = {};

        self.getUserFeedbacks();
    }

    searchUserFeedbacks() {
        const self = this;

        self.userFeedbacksFiltered = self.userFeedbacks;
        self.apiOffset = 0;
        self.selectedPage = 1;

        if (typeof(self.searchParams.text) != "undefined" && self.searchParams.text != '') {
            self.searchVal = self.searchParams.text.toString().toLowerCase();
            self.userFeedbacksFiltered = _.filter(self.userFeedbacks, function (feedback) {
                if (startsWith(feedback['email'].toLowerCase(), self.searchVal) ||
                    startsWith(feedback['first_name'].toLowerCase(), self.searchVal) ||
                    startsWith(feedback['last_name'].toLowerCase(), self.searchVal) ||
                    startsWith(feedback['phone1'].toLowerCase(), self.searchVal)
                ) {
                    return feedback;
                }
            });
        } else if (typeof(self.searchParams.feedbackTypes) != "undefined" && self.searchParams.feedbackTypes != '') {
            self.searchVal2 = self.searchParams.feedbackTypes;
            self.userFeedbacksFiltered = _.filter(self.userFeedbacks, function (feedback) {
                if (feedback['type'] == self.searchVal2) {
                    return feedback;
                }
            });
        } else {
            self.getUserFeedbacks();
        }
    }

    pagesGoBack() {
        const self = this;

        self.selectedPage--;
        self.apiOffset = self.apiOffset - self.apiLimit;

        self.getUserFeedbacks();
    }

    pagesGoNext() {
        const self = this;

        self.selectedPage++;
        self.apiOffset = self.apiOffset + self.apiLimit;

        self.getUserFeedbacks();
    }

    downloadUserFeedback() {
        const self = this;

        let url = self.SSHttpService.getServerURL('super/users-feedback/export');

        self.searchParams.offset = self.apiOffset;
        self.searchParams.limit = self.apiLimit;

        let params = jQuery.param(self.searchParams);

        self.SSUtilService.openUrlInNewTab(url + '?' + params);
    }

}

SuperUserFeedbackViewController.$inject = ['$scope', '$parse', 'SSHttpService', 'SSUtilService', 'SSAppService', 'SSAlertService', 'OTPService', 'SSUserService'];
app.controller('SuperUserFeedbackViewController', SuperUserFeedbackViewController);

